import { define, auto } from 'type-r'
import View from './view.js'

@define
export default class Econcal extends View {
    initialize() {
        $.get('/getcal', function (data: any) {
            $(this.el).html(data);
        });
    }
}


